import { Suspense, useMemo, useRef } from 'react'
import { useGLTF, Environment, PresentationControls, Float, Text, Html } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'

const MODEL_URL = 'https://vazxmixjsiawhamofees.supabase.co/storage/v1/object/public/models/macbook/model.gltf'

useGLTF.preload(MODEL_URL)

function Loader() {
	return (
		<Html center>
			<div className="loader">LOADING...</div>
		</Html>
	)
}

export default function Experience() {
	const { scene } = useGLTF(MODEL_URL)
	const optimizedScene = useMemo(() => scene.clone(), [scene])
	const screenLightRef = useRef()

	useFrame((state) => {
		if (screenLightRef.current) {
			screenLightRef.current.intensity = (1 + Math.sin(state.clock.elapsedTime * 2)) * 0.5
		}
	})

	return (
		<Suspense fallback={<Loader />}>
			<color args={['#000000']} attach="background" />
			<Environment preset='city' />
			
			<PresentationControls
				global
				rotation={[0.13, 0.1, 0]}
				polar={[-0.4, 0.2]}
				azimuth={[-1, 0.75]}
				config={{ mass: 2, tension: 400 }}
				snap={{ mass: 4, tension: 400 }}
			>
				<Float rotationIntensity={0.4}>
					<primitive object={optimizedScene} position-y={-1.2}>
						<Html
							transform
							wrapperClass="htmlScreen"
							distanceFactor={1.17}
							position={[0, 1.56, -1.4]}
							rotation-x={-0.256}
						>
							<iframe src="https://hiteshchouhan.netlify.app/" loading="lazy" />
						</Html>
					</primitive>
					<Text
						fontSize={1}
						position={[2, 0.75, 0.75]}
						rotation-y={-1.25}
						textAlign="center"
						font="/bangers-v20-latin-regular.woff"
					>
						HITESH{'\n'}CHOUHAN
					</Text>
				</Float>
			</PresentationControls>
		</Suspense>
	)
}